import React from 'react'
import Power from '@assets/power.svg'
import InfoIcon from '@assets/info.svg'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@components/Tooltip'

const StakingPower = ({
  stakingAmount,
}: {
  stakingAmount: number | undefined
}) => {
  return (
    <div className={`flex border-dark-6 border-t-[1px]`}>
      <div className="flex p-4 gap-2 text-sm font-semibold w-full">
        <Power color={'white'} />
        <span>Staking Power</span>
        <span>{stakingAmount}</span>

        <div className="flex flex-1 items-end justify-end">
          <div className="flex items-center justify-center rounded-full hover:bg-dark-5 cursor-pointer p-[0.5px]">
            <TooltipProvider delayDuration={0}>
              <Tooltip>
                <TooltipTrigger>
                  <InfoIcon color="var(--dewi_colors_dark_3)" />
                </TooltipTrigger>
                <TooltipContent className="max-w-[300px] mr-12 p-4">
                  <p className="text-xs text-white font-semibold">
                    The total staking power of this auction is based on staked
                    cats before auction creation. Legendary cats have 2x staking
                    power, while regular cats have 1x.
                  </p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          </div>
        </div>
      </div>
    </div>
  )
}

export default StakingPower
